// removed by extract-text-webpack-plugin
module.exports = {"SocialShareButton":"SocialShare__SocialShareButton__33LGE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialShare/SocialShare.css
// module id = 528
// module chunks = 0